import selectAttachmentPreferencesOption from '../actions/selectAttachmentPreferencesOption';
import AttachmentPreferencesOptionState, {
    AttachOrSharePreference,
} from '../store/schema/AttachmentPreferencesOptionState';
import { ChoiceGroup, IChoiceGroupOption } from 'office-ui-fabric-react/lib/ChoiceGroup';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { observer } from 'mobx-react';

export interface AttachmentPreferencesChoiceGroupProps {
    selectedKey: AttachOrSharePreference;
    label: string;
    optionKey: keyof AttachmentPreferencesOptionState;
}

@observer
export default class AttachmentPreferencesChoiceGroup extends React.Component<
    AttachmentPreferencesChoiceGroupProps,
    {}
> {
    render() {
        let { selectedKey, label } = this.props;

        return (
            <ChoiceGroup
                selectedKey={`${selectedKey}`}
                label={label}
                options={[
                    {
                        key: `${AttachOrSharePreference.None}`,
                        text: strings.options_attachmentPreferences_askOption,
                    },
                    {
                        key: `${AttachOrSharePreference.Share}`,
                        text: strings.options_attachmentPreferences_shareOption,
                    },
                    {
                        key: `${AttachOrSharePreference.Attach}`,
                        text: strings.options_attachmentPreferences_attachOption,
                    },
                ]}
                onChange={this.onChange}
            />
        );
    }

    private onChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        option?: IChoiceGroupOption
    ) => {
        selectAttachmentPreferencesOption(this.props.optionKey, parseInt(option.key, 10));
    };
}
